<label class="checkbox__wrapper">
    @if (labelPosition === 'left') {
        <span class="checkbox__label checkbox__label--left">
            <ng-container *ngTemplateOutlet="label"></ng-container>
        </span>
    }
    <input
            type="checkbox"
            [checked]="checked"
            (change)="onInput()"
            [disabled]="isDisabled"
    >
    <span class="checkbox"></span>
    @if (labelPosition === 'right') {
        <span class="checkbox__label checkbox__label--right">
            <ng-container *ngTemplateOutlet="label"></ng-container>
        </span>
    }
</label>

<ng-template #label>
    <ng-content></ng-content>
</ng-template>
